const nft1 = `${process.env.PUBLIC_URL}/img/NFT/nft_1.jpg`;
const nft2 = `${process.env.PUBLIC_URL}/img/NFT/nft_2.jpg`;
const nft3 = `${process.env.PUBLIC_URL}/img/NFT/nft_3.jpg`;
const nft4 = `${process.env.PUBLIC_URL}/img/NFT/nft_4.jpg`;

// eslint-disable-next-line import/prefer-default-export
export const NFTItems = [
  {
    id: 111,
    date: '2022-05-09 16:54',
    nft_id: '0xe9be55ffedb6c2a2f3f8eac31e60d7f122f799',
    name: 'Bored Ape #387',
    price: '2500.00 ETH',
    side: 'In',
    image: nft1,
  },
  {
    id: 222,
    date: '2022-05-09 16:54',
    nft_id: '0xe9be55ffedb6c2a2f3f8eac31e60d7f122f799',
    name: 'Nyan Cat',
    price: '8990.00 ETH',
    side: 'In',
    image: nft2,
  },
  {
    id: 333,
    date: '2022-05-09 16:54',
    nft_id: '0xe9be55ffedb6c2a2f3f8eac31e60d7f122f799',
    name: 'Bored Ape #132',
    price: '1900.00 ETH',
    side: 'In',
    image: nft3,
  },
  {
    id: 444,
    date: '2022-05-09 16:54',
    nft_id: '0xe9be55ffedb6c2a2f3f8eac31e60d7f122f799',
    name: 'Crypto Punk #4583',
    price: '1900.00 ETH',
    side: 'In',
    image: nft4,
  },
  {
    id: 555,
    date: '2022-05-09 16:54',
    nft_id: '0xe9be55ffedb6c2a2f3f8eac31e60d7f122f799',
    name: 'Crypto Punk #4583',
    price: '1900.00 ETH',
    side: 'In',
    image: nft4,
  },
];
